import styles from '@/styles/chat.module.scss';

/**
 * ChannelButton — кнопка выбора канала связи (иконка + подпись).
 */
export default function ChannelButton({ icon, iconBg, label, onClick }) {
  return (
    <button className={styles.channelBtn} onClick={onClick} type="button">
      <span className={styles.channelIcon} style={{ background: iconBg }}>
        {icon}
      </span>
      {label}
    </button>
  );
}
